export const initialOptions: RequestInit = {
  method: 'POST',
  mode: 'cors',
  cache: 'no-cache' as RequestCache,
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `cVQ-h9G7QPCs3ErRdmsGNE:APA91bGlsWbE6ouc9jbIskdJOSF0SqwWq-9HXGGeewcs5ESpH-ryhoKYgcYIx19Iay_geMmufvWNb0M6woPo1jYNvIS0tiGZjXluSDuDbLeHyDeHJJ1ZGL_eq06EVb_0AyfsVeCjHND8`,
  },
  redirect: 'follow',
  referrerPolicy: 'no-referrer',
};
